import { useCallback, useState } from 'react';

const useToggleState = (
  initialState: boolean = false,
): [boolean, () => void] => {
  const [state, setState] = useState<boolean>(initialState);

  const toggle = useCallback(() => {
    setState(prevState => !prevState);
  }, []);

  return [state, toggle];
};

export default useToggleState;
